import React, { useState, useEffect } from 'react';
import axios from 'axios';
// import {API_URL} from "../config";
import { 
    List, Button, Input, Space, Card, Typography, Layout, Spin, Alert, Form, 
    Select, Modal, message, Badge, Tooltip, Drawer, Tag, InputNumber
} from 'antd';
import { 
    SearchOutlined, ReloadOutlined, FilterOutlined, SortAscendingOutlined, 
    SortDescendingOutlined, SaveOutlined, DeleteOutlined, CheckCircleOutlined, 
    CloseCircleOutlined, MenuOutlined
} from '@ant-design/icons';
// // import {baseUrl_new} from "../../api/BaseUrl";
// import {API_URL} from "../src/config/";
import {API_URL} from "../../config";
const { Title, Text } = Typography;
const { Content } = Layout;
const { Search } = Input;
const { Option } = Select;

const StocksMobile = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [error, setError] = useState(null);
    const [sortByPresent, setSortByPresent] = useState(() => {
        const savedSort = localStorage.getItem('stocksSortByPresent');
        return savedSort ? JSON.parse(savedSort) : null;
    });
    const [filters, setFilters] = useState(() => {
        const savedFilters = localStorage.getItem('stocksFilters');
        return savedFilters ? JSON.parse(savedFilters) : {
            article: '',
            color: '',
            shortName: '',
            present: '',
            search: ''
        };
    });
    const [searchValue, setSearchValue] = useState(() => filters.search || '');
    const [previewImage, setPreviewImage] = useState('');
    const [previewVisible, setPreviewVisible] = useState(false);
    const [modifiedItems, setModifiedItems] = useState({});
    const [originalValues, setOriginalValues] = useState({});
    const [successfulUpdates, setSuccessfulUpdates] = useState(new Set());
    const [saveResults, setSaveResults] = useState(null);
    const [filterDrawerVisible, setFilterDrawerVisible] = useState(false);

    const [form] = Form.useForm();

    const quickFilters = [
        { name: 'Баффы', value: 'BN-' },
        { name: 'Хобы', value: 'HB-PRO' },
        { name: 'SUM', value: 'BN-SUM' },
        { name: 'PRO', value: 'BN-PRO' },
        { name: 'ZIM', value: 'BN-ZIM' },
        { name: 'NEO', value: 'BN-NEO' },
        { name: 'JS', value: 'BN-JS' },
        { name: 'BS', value: 'BN-BS' }

    ];

    useEffect(() => {
        form.setFieldsValue({
            ...filters,
            sort_by_present: sortByPresent
        });
    }, []);

    useEffect(() => {
        localStorage.setItem('stocksFilters', JSON.stringify(filters));
    }, [filters]);

    useEffect(() => {
        localStorage.setItem('stocksSortByPresent', JSON.stringify(sortByPresent));
    }, [sortByPresent]);

    const fetchData = async (
        page = 1,
        newSearch = false,
        sortOrder = sortByPresent,
        activeFilters = filters
    ) => {
        try {
            setLoading(true);
            setError(null);
            const params = {
                page,
                sort_by_present: sortOrder,
                sort_by_article: sortOrder === null ? 'asc' : null
            };

            if (activeFilters.article) params.article = activeFilters.article;
            if (activeFilters.color) params.color = activeFilters.color;
            if (activeFilters.shortName) params.shortName = activeFilters.shortName;
            if (activeFilters.search) params.search = activeFilters.search;
            if (activeFilters.present !== '' && activeFilters.present != null) {
                params.present = parseInt(activeFilters.present, 10);
            }
            const token = localStorage.getItem('token');
            const headers = token ? { Authorization: `Bearer ${token}` } : {};
            const response = await axios.get(`${API_URL}/v1/stocks/items`, {
                params,
                headers
            });
            const newOriginalValues = {};
            response.data.items.forEach(item => {
                newOriginalValues[item.article] = item.present;
            });

            if (newSearch) {
                setData(response.data.items);
                setOriginalValues(newOriginalValues);
            } else {
                setData(prevData => [...prevData, ...response.data.items]);
                setOriginalValues(prev => ({
                    ...prev,
                    ...newOriginalValues
                }));
            }
            
            setHasMore(page < response.data.total_pages);
            setCurrentPage(page);
        } catch (error) {
            setError('Ошибка при загрузке данных. Пожалуйста, попробуйте позже.');
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleFiltersSubmit = (values) => {
        const newFilters = {
            article: values.article || '',
            color: values.color || '',
            shortName: values.shortName || '',
            present: values.present || '',
            search: filters.search || ''
        };
        
        setSortByPresent(values.sort_by_present || null);
        setFilters(newFilters);
        setCurrentPage(1);
        fetchData(1, true, values.sort_by_present || null, newFilters);
        setFilterDrawerVisible(false);
    };

    const handleFiltersClear = () => {
        form.resetFields();
        const emptyFilters = {
            article: '',
            color: '',
            shortName: '',
            present: '',
            search: ''
        };
        setSearchValue('');
        setFilters(emptyFilters);
        setSortByPresent(null);
        setCurrentPage(1);
        fetchData(1, true, null, emptyFilters);
        setFilterDrawerVisible(false);
    };

    const handleQuantityChange = (article, newValue) => {
        const numValue = parseInt(newValue);
        if (!isNaN(numValue) && numValue >= 0) {
            let updatedModifiedItems = { ...modifiedItems };

            // Сравниваем с оригинальным значением
            if (originalValues[article] === numValue) {
                delete updatedModifiedItems[article];
            } else {
                updatedModifiedItems[article] = numValue;
            }

            if (article.startsWith('HB')) {
                const numericPart = article.match(/\d+/)?.[0];
                if (numericPart) {
                    const variants = [
                        `HB-PRO-${numericPart}`,
                        `HB-EXT-${numericPart}`,
                        `HB-STD-${numericPart}`
                    ];

                    variants.forEach(variant => {
                        if (variant !== article && updatedModifiedItems[variant] !== undefined) {
                            updatedModifiedItems[variant] = numValue;
                            if (!originalValues[variant]) {
                                const variantItem = data.find(item => item.article === variant);
                                setOriginalValues(prev => ({
                                    ...prev,
                                    [variant]: variantItem?.present || 0
                                }));
                            }
                        }
                    });
                }
            }

            setModifiedItems(updatedModifiedItems);
            setData(prevData => 
                prevData.map(item => 
                    item.article === article 
                        ? { ...item, present: numValue }
                        : item
                )
            );
        }
    };

    const handleSaveChanges = async () => {
        try {
            setLoading(true);
            setSaveResults(null);

            const allChanges = Object.entries(modifiedItems).map(([article, present]) => {
                const changes = [{
                    article,
                    present
                }];

                if (article.startsWith('HB')) {
                    const numericPart = article.match(/\d+/)?.[0];
                    if (numericPart) {
                        const variants = [
                            `HB-PRO-${numericPart}`,
                            `HB-EXT-${numericPart}`,
                            `HB-STD-${numericPart}`
                        ];
                        
                        variants.forEach(variant => {
                            if (variant !== article && modifiedItems[variant] !== undefined) {
                                changes.push({
                                    article: variant,
                                    present: modifiedItems[variant]
                                });
                            }
                        });
                    }
                }

                return changes;
            }).flat();

            const uniqueChanges = Array.from(
                new Map(allChanges.map(item => [item.article, item])).values()
            );

            const changesForBackend = {
                items: uniqueChanges
            };

            const token = localStorage.getItem('token');
            const headers = token ? { Authorization: `Bearer ${token}` } : {};

            const response = await axios.put(`${API_URL}/v1/stocks/update-quantities`, changesForBackend, { headers });
            const results = response.data;
            setSaveResults(results);
            
            const newSuccessfulUpdates = new Set(successfulUpdates);
            results.results.forEach(result => {
                if (result.updated && !result.errors?.length) {
                    newSuccessfulUpdates.add(result.offer_id);
                }
            });
            setSuccessfulUpdates(newSuccessfulUpdates);

            if (results.status === 'success') {
                message.success('Все изменения успешно сохранены');
                setModifiedItems({});
                fetchData(currentPage, true, sortByPresent);
            } else if (results.status === 'partial_success') {
                message.warning(`Сохранено ${results.successful_count} из ${results.successful_count + results.failed_count} изменений`);
                fetchData(currentPage, true, sortByPresent);
            } else {
                message.error('Ошибка при сохранении изменений');
            }
        } catch (error) {
            console.error('Error saving changes:', error);
            message.error(error.response?.data?.error || 'Ошибка при сохранении изменений');
            setSaveResults({
                status: 'error',
                message: error.response?.data?.error || 'Ошибка при сохранении изменений'
            });
        } finally {
            setLoading(false);
        }
    };

    const handleCancelChanges = () => {
        setData(prevData => 
            prevData.map(item => ({
                ...item,
                present: originalValues[item.article] || item.present
            }))
        );
        setModifiedItems({});
        setOriginalValues({});
        setSuccessfulUpdates(new Set());
        setSaveResults(null);
        message.info('Изменения отменены');
    };

    const handleQuickFilter = (filterValue) => {
        form.setFieldValue('article', filterValue);
        const formValues = form.getFieldsValue();
        formValues.article = filterValue;
        handleFiltersSubmit(formValues);
    };

    const handleCombinedSearch = (value) => {
        const search = String(value || '').trim();
        const newFilters = { ...filters, search };
        setSearchValue(search);
        setFilters(newFilters);
        setCurrentPage(1);
        fetchData(1, true, sortByPresent, newFilters);
    };

    const handleRemoveChange = (article) => {
        // Восстанавливаем оригинальное значение в данных
        setData(prevData => 
            prevData.map(item => 
                item.article === article 
                    ? { ...item, present: originalValues[article] || item.present }
                    : item
            )
        );

        // Удаляем из списка измененных элементов
        const updatedModifiedItems = { ...modifiedItems };
        delete updatedModifiedItems[article];
        setModifiedItems(updatedModifiedItems);

        // Удаляем из списка успешных обновлений
        const newSuccessfulUpdates = new Set(successfulUpdates);
        newSuccessfulUpdates.delete(article);
        setSuccessfulUpdates(newSuccessfulUpdates);

        message.info(`Изменения для ${article} отменены`);
    };

    useEffect(() => {
        fetchData(1, true, sortByPresent);
    }, []);

    const renderListItem = (item) => {
        const isModified = modifiedItems[item.article] !== undefined;
        const isSuccessful = successfulUpdates.has(item.article);
        const saveResult = saveResults?.results?.find(r => r.offer_id === item.article);

        return (
            <List.Item
                style={{
                    background: isSuccessful ? '#f6ffed' : isModified ? '#e6f7ff' : 'white',
                    borderLeft: isSuccessful ? '3px solid #52c41a' : 
                              isModified ? '3px solid #1890ff' : 
                              '3px solid transparent',
                    padding: '8px',
                    marginBottom: '4px'
                }}
            >
                <Space direction="vertical" style={{ width: '100%' }} size={2}>
                    <Space align="start" style={{ width: '100%', justifyContent: 'space-between' }}>
                        <Space size={6}>
                            {item.primary_image && (
                                <img
                                    src={item.primary_image}
                                    alt="product"
                                    style={{
                                        width: '40px',
                                        height: '40px',
                                        objectFit: 'contain',
                                        borderRadius: '3px'
                                    }}
                                    onClick={() => {
                                        setPreviewImage(item.primary_image);
                                        setPreviewVisible(true);
                                    }}
                                />
                            )}
                            <Space direction="vertical" size={0}>
                                <Text strong style={{ fontSize: '13px' }}>{item.article}</Text>
                                <Text type="secondary" style={{ fontSize: '11px' }}>{item.shortName}</Text>
                                <Tag color="blue" style={{ fontSize: '10px', padding: '0 4px' }}>{item.Color}</Tag>
                            </Space>
                        </Space>
                        <Space direction="vertical" align="end" size={2}>
                            <Space size={4}>
                                <InputNumber
                                    size="small"
                                    min={0}
                                    value={modifiedItems[item.article] ?? item.present}
                                    onChange={(value) => handleQuantityChange(item.article, value)}
                                    style={{
                                        width: '80px',
                                        backgroundColor: isModified ? '#e6f7ff' : 'white'
                                    }}
                                />
                                {isModified && (
                                    <Button
                                        type="text"
                                        size="small"
                                        danger
                                        icon={<DeleteOutlined />}
                                        onClick={() => handleRemoveChange(item.article)}
                                    />
                                )}
                            </Space>
                            {isModified && (
                                <Text type="secondary" style={{ fontSize: '10px' }}>
                                    Было: {originalValues[item.article]}
                                </Text>
                            )}
                        </Space>
                    </Space>
                    {saveResult?.errors?.length > 0 && (
                        <Alert
                            message="Ошибки обновления"
                            description={saveResult.errors.join(', ')}
                            type="error"
                            showIcon
                            style={{ marginTop: '4px' }}
                            size="small"
                        />
                    )}
                </Space>
            </List.Item>
        );
    };

    return (
        <Layout style={{
            background: '#f0f2f5',
            minHeight: '100vh',
            width: '100%',
            position: 'relative'
        }}>
            <div style={{
                position: 'fixed',
                top: 0,
                left:  0,
                right: 0,
                zIndex: 100,
                padding: '12px',
                background: '#f0f2f5',
                transition: 'left 0.3s ease-in-out'
            }}>
                <Space direction="vertical" style={{ width: '100%' }} size={4}>
                    <Space style={{ width: '100%', justifyContent: 'space-between' }}>
                        <Space>
                            <Button
                                size="small"
                                icon={<MenuOutlined />}
                                onClick={() => setFilterDrawerVisible(true)}
                            />
                            <Title level={5} style={{ margin: 0 }}>Остатки</Title>
                        </Space>
                        <Space>
                            {Object.keys(modifiedItems).length > 0 && (
                                <Badge count={Object.keys(modifiedItems).length} />
                            )}
                            <Button
                                size="small"
                                icon={<ReloadOutlined />}
                                onClick={() => fetchData(1, true)}
                            />
                        </Space>
                    </Space>

                    <Card size="small" bodyStyle={{ padding: '4px' }}>
                        <Space wrap size={2}>
                            {quickFilters.map((filter, index) => (
                                <Button
                                    key={index}
                                    size="small"
                                    type={filters.article === filter.value ? 'primary' : 'default'}
                                    onClick={() => handleQuickFilter(filter.value)}
                                    style={{ fontSize: '11px', padding: '0 6px' }}
                                >
                                    {filter.name}
                                </Button>
                            ))}
                        </Space>
                    </Card>
                    <Search
                        value={searchValue}
                        placeholder="Поиск по наименованию или артикулу"
                        allowClear
                        enterButton
                        onChange={(event) => {
                            const value = event.target.value;
                            setSearchValue(value);
                            if (!value && filters.search) {
                                handleCombinedSearch('');
                            }
                        }}
                        onSearch={handleCombinedSearch}
                    />
                </Space>
            </div>

            <Content style={{
                position: 'fixed',
                top: 145,
                left: 0,
                right: 0,
                bottom: 'calc(92px + env(safe-area-inset-bottom))',
                padding: '12px',
                transition: 'all 0.3s ease-in-out',
                overflowY: 'auto'
            }}>
                {error && (
                    <Alert
                        message="Ошибка"
                        description={error}
                        type="error"
                        showIcon
                        style={{ marginBottom: '8px' }}
                        size="small"
                    />
                )}

                <List
                    loading={loading}
                    dataSource={data}
                    renderItem={renderListItem}
                    style={{ background: 'white', borderRadius: '6px' }}
                />

                {hasMore && (
                    <div style={{ textAlign: 'center', margin: '12px 0' }}>
                        <Button size="small" onClick={() => fetchData(currentPage + 1)} loading={loading}>
                            Загрузить еще
                        </Button>
                    </div>
                )}

                {Object.keys(modifiedItems).length > 0 && (
                    <div style={{
                        position: 'fixed',
                        bottom: 'calc(92px + env(safe-area-inset-bottom))',
                        left: 0,
                        right: 0,
                        padding: '8px',
                        background: 'white',
                        boxShadow: '0 -2px 8px rgba(0,0,0,0.1)',
                        zIndex: 100
                    }}>
                        <Space style={{ width: '100%', justifyContent: 'space-between' }}>
                            <Space>
                                <Badge count={Object.keys(modifiedItems).length} style={{ backgroundColor: '#1890ff' }} />
                                <Text style={{ fontSize: '12px' }}>Изменено</Text>
                            </Space>
                            <Space>
                                <Button onClick={handleCancelChanges} size="small">
                                    Очистить
                                </Button>
                                <Button
                                    type="primary"
                                    icon={<SaveOutlined />}
                                    onClick={handleSaveChanges}
                                    loading={loading}
                                    size="small"
                                >
                                    Отправить
                                </Button>
                            </Space>
                        </Space>
                    </div>
                )}
            </Content>

            <Drawer
                title="Фильтры"
                placement="left"
                onClose={() => setFilterDrawerVisible(false)}
                visible={filterDrawerVisible}
                width="100%"
                zIndex={10000}
            >
                <Form
                    form={form}
                    onFinish={handleFiltersSubmit}
                    layout="vertical"
                    initialValues={{
                        ...filters,
                        sort_by_present: sortByPresent
                    }}
                >
                    <Form.Item name="article" label="Артикул">
                        <Input placeholder="Поиск по артикулу" />
                    </Form.Item>
                    <Form.Item name="shortName" label="Наименование">
                        <Input placeholder="Поиск по наименованию" />
                    </Form.Item>
                    <Form.Item name="color" label="Цвет">
                        <Input placeholder="Поиск по цвету" />
                    </Form.Item>
                    <Form.Item name="present" label="Количество">
                        <Input type="number" placeholder="Поиск по количеству" />
                    </Form.Item>
                    <Form.Item name="sort_by_present" label="Сортировка по количеству">
                        <Select placeholder="Выберите порядок сортировки" allowClear>
                            <Option value="asc">По возрастанию</Option>
                            <Option value="desc">По убыванию</Option>
                        </Select>
                    </Form.Item>
                    <Space style={{ width: '100%', justifyContent: 'flex-end' }}>
                        <Button onClick={handleFiltersClear}>
                            Сбросить
                        </Button>
                        <Button type="primary" htmlType="submit">
                            Применить
                        </Button>
                    </Space>
                </Form>
            </Drawer>

            <Modal
                visible={previewVisible}
                footer={null}
                onCancel={() => setPreviewVisible(false)}
            >
                <img
                    alt="preview"
                    style={{ width: '100%' }}
                    src={previewImage}
                />
            </Modal>
        </Layout>
    );
};

export default StocksMobile; 